import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../redux/store';
import { setPatientDetails } from '../../redux/slices/appointmentSlice';
import { getLegalUrl } from '../../utils/helpers';
import { LEGAL_PAGES } from '../../utils/constants';

const DEFAULT_PRACTICE_TITLE = 'our practice';

const LEGAL_LINK_CLASS = 'text-teamcare-blue underline';

export const SmsConsentField = () => {
  const dispatch = useDispatch();
  const patientDetails = useSelector((s: RootState) => s.appointment.patientDetails);
  const practiceTitle = useSelector((s: RootState) => s.auth.practice?.title) || DEFAULT_PRACTICE_TITLE;
  const { practiceId } = useParams<{ practiceId: string }>();

  const handleChange = (checked: boolean) => {
    dispatch(setPatientDetails({ ...patientDetails, smsConsent: checked }));
  };

  return (
    <div className="form-control pt-1">
      <label className="flex items-start gap-2 cursor-pointer">
        <input
          type="checkbox"
          className="checkbox checkbox-sm border-teamcare-blue mt-1 shrink-0"
          checked={Boolean(patientDetails.smsConsent)}
          onChange={(e) => handleChange(e.target.checked)}
        />
        <span className="text-sm text-gray-600 leading-relaxed">
          I agree to receive text messages from {practiceTitle} about my
          appointments, including confirmations, reminders, and follow-ups.
          Message frequency varies. Message and data rates may apply. Reply
          STOP to opt out, HELP for help. See our{' '}
          <a
            href={getLegalUrl(practiceId, LEGAL_PAGES.privacyPolicy)}
            target="_blank"
            rel="noopener noreferrer"
            className={LEGAL_LINK_CLASS}
          >
            Privacy Policy
          </a>{' '}
          and{' '}
          <a
            href={getLegalUrl(practiceId, LEGAL_PAGES.termsOfUse)}
            target="_blank"
            rel="noopener noreferrer"
            className={LEGAL_LINK_CLASS}
          >
            Terms
          </a>
          .
        </span>
      </label>
    </div>
  );
};
